import * as React from 'react';

export type BadgeSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';

interface Props extends React.ComponentProps<'div'> {
  size?: BadgeSize;
}

const sizes: Record<BadgeSize, string> = {
  xs: 'w-6 h-6 text-xs font-medium',
  sm: 'w-8 h-8 text-xs font-medium',
  md: 'w-10 h-10 font-medium',
  lg: 'w-16 h-16 text-2xl font-medium',
  xl: 'w-24 h-24 text-5xl',
  xxl: 'w-32 h-32 text-6xl',
};

export const Badge: React.FC<Props> = ({
  className = '',
  size = 'md',
  ...props
}) => {
  return (
    <div
      className={`text-white ${sizes[size]} flex justify-center items-center rounded-full flex-shrink-0 overflow-hidden ${className}`}
      {...props}
    />
  );
};
